import React, { useEffect, useState } from "react";
import ContractAdvancedSecurityTable from "../ContractAdvancedSecurity";
import ContractClientDetailsTable from "./ContractClientDetailsTable";
import ContractCompanyDetailsTable from "./ContractCompanyDetailsTable";
import ContractCostSheetTable from "./ContractCostSheetTable";
import ContractFilesTable from "./ContractFilesTable";
import { useLocation } from "react-router-dom";

const MoreDetails = ({
  contractDetails,
  updateComponent,
  setContractFileUploadState,
  contractId,
}) => {
  const location = useLocation();
  const state = location?.state;
  const [selectedFileType, setSelectedFileType] = useState(
    state?.detailType || "COST SHEET"
  );

  useEffect(() => {
    updateComponent((prevState) => Math.random());
  }, [location.state]);

  return (
    <>
      <div className="flex flex-wrap  min-w-full w-full gap-2  bg-slate-200 p-2 rounded-md">
        {[
          "COST SHEET",
          "FILES",
          "VISA PROVIDERS DETAILS",
          "CLIENT DETAILS",
        ].map((e, i) => (
          <button
            key={i}
            className={`p-2 rounded-md sm:w-52 w-full   ${
              selectedFileType === e
                ? "bg-red text-white"
                : "bg-white text-black"
            }`}
            onClick={() => {
              // setFilesLoading(true);
              setSelectedFileType(e);
              setTimeout(() => {
                //   setFilesLoading(false);
              }, 500);
            }}
          >
            {e}
          </button>
        ))}
      </div>
      {selectedFileType === "VISA PROVIDERS DETAILS" && (
        <ContractCompanyDetailsTable contractDetails={contractDetails} />
      )}
      {selectedFileType === "CLIENT DETAILS" && (
        <ContractClientDetailsTable contractDetails={contractDetails} />
      )}
      {selectedFileType === "FILES" && (
        <ContractFilesTable
          contractDetails={contractDetails}
          updateComponent={updateComponent}
          setContractFileUploadState={setContractFileUploadState}
        />
      )}

      {selectedFileType === "COST SHEET" && (
        <ContractCostSheetTable
          contractDetails={contractDetails}
          updateComponent={updateComponent}
          contractId={contractId}
        />
      )}
    </>
  );
};

export default MoreDetails;
